exports.__esModule = true;
var __importDefault = function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var docs_config_1 = __importDefault(require("@tencent/docs-config"));
var appConfigInstance = docs_config_1.default.getInstance();
var npmConfig = appConfigInstance.getConfig('npm["@tencent/docs-design-resources"]')
exports.default = (function () {
    var p = (npmConfig === null || npmConfig === void 0 ? void 0 : npmConfig.CDN_ORIGIN) || "https://docs.gtimg.com/docs-design-resources";
    p = p + "/document-management/private-tdocs/svg/"
    return {
        "application-vnd.tdocs-apps.collaboration-space-root": p+"application-vnd.tdocs-apps.collaboration-space-root.svg",
    };
})();